export const PageMixin = {
  data () {
    return {
      refreshing: false, // 下拉刷新
      loading: false, // 上拉加载
      finished: false, // 上拉加载完成
      error: false, // 是否上拉加载失败
      pageNo: 0, // 当前页码
      pageSize: 20, // 每页数量
      total: 0, // 总条数
      dataList: [], // 数据列表
      queryParams: {}, // 搜索条件
      disableMixinCreated: false // 禁用初始化加载数据
    }
  },
  computed: {
    finishedText: {
      get () {
        return this.error ? '' : '到底啦~' // 上拉加载完成后的提示文案
      }
    }
  },
  created () {
    if (!this.disableMixinCreated) {
      this.onLoad()
    }
  },
  methods: {
    /**
     * 下拉刷新
     */
    onRefresh (pageSize = 20, refreshing = true) {
      this.refreshing = refreshing
      this.loading = false
      this.finished = false
      this.pageNo = 1
      this.total = 0
      this.pageSize = pageSize
      this.getDataList()
    },

    /**
     * 上拉加载
     */
    onLoad () {
      this.pageNo++
      if (this.pageNo === 1) {
        this.dataList = []
      }
      this.getDataList()
    },

    async getDataList () {
      if (!this.url.list) {
        this.$toast('请设置 url.list 属性！')
        return
      }
      const params = this.getQueryParams()
      await this.$http.getAction(this.url.list, params).then(res => {
        this.processResult(res)
      }).catch(() => {
        this.finished = true
        this.error = true
      }).finally(() => {
        this.refreshing = false
        this.loading = false
      })
      console.log('load remote data ...')
    },
    getQueryParams () {
      return Object.assign(this.queryParams, { pageNo: this.pageNo, pageSize: this.pageSize })
    },
    processResult (res) {
      if (res.success) {
        this.total = res.data.total
        if (res.data.current >= res.data.pages) {
          this.finished = true
        }

        if (res.data.current === 1) {
          this.dataList = []
          this.finished = false
        }
        this.dataList = this.dataList.concat(res.data.records)
      }
    }
  }
}
